import { v4 as uuidv4 } from 'uuid';

const GUEST_ID_STORAGE_KEY = 'sseTokenId';
const SEARCH_GUEST_ID_STORAGE_KEY = 'searchGuestId';

const getOrCreateStoredGuestId = (storageKey: string): string => {
    const existing = localStorage.getItem(storageKey);
    if (existing) return existing;

    const guestId = uuidv4();
    localStorage.setItem(storageKey, guestId);
    return guestId;
};

export const getOrCreateGuestId = (): string => getOrCreateStoredGuestId(GUEST_ID_STORAGE_KEY);

export const getOrCreateSearchGuestId = (): string =>
    getOrCreateStoredGuestId(SEARCH_GUEST_ID_STORAGE_KEY);
